import React from "react";
import { handleDataType } from "../../utils/Helper";
import ArrayDatatype from "./array-datatype";
import BooleanDatatype from "./boolean-datatype";
import NumberDatatype from "./number-datatype";
import ObjectDatatype from "./object-datatype";
import StringDatatype from "./string-datatype";

function DisplayData({ value, inner, flag }) {
  let type = handleDataType(value);

  function handleOutputDisplay(type) {
    switch (type) {
      case "STRING":
        return <StringDatatype value={value} flag={flag} />;
      case "NUMBER":
        return <NumberDatatype value={value} />;
      case "BOOLEAN":
        return <BooleanDatatype value={value} />;
      case "ARRAY":
        if (inner) {
          return (
            <span
              style={{ color: "whitesmoke" }}
            >{`Array(${value.length})`}</span>
          );
        } else {
          return <ArrayDatatype value={value} />;
        }
      case "OBJECT":
        if (inner) {
          return <span style={{ color: "whitesmoke" }}>{`{...}`}</span>;
        } else {
          return <ObjectDatatype value={value} />;
        }
      case "MAP":
        return (
          <span style={{ color: "whitesmoke" }}>{`Map(${value.size})`}</span>
        );
      case "COMPLEX_OBJECT":
        return <StringDatatype value={value.toString()} />;
      case "UNDEFINED":
        return (
          <span style={{ color: "#c65cb3", fontFamily: "Roboto Mono" }}>
            undefined
          </span>
        );
      case "NULL":
        return (
          <span style={{ color: "#c65cb3", fontFamily: "Roboto Mono" }}>
            null
          </span>
        );
      case "NAN":
        return (
          <span style={{ color: "#c65cb3", fontFamily: "Roboto Mono" }}>
            NaN
          </span>
        );
      case "FUNCTION":
        return (
          <>
            <span style={{ color: "#c65cb3", fontFamily: "Roboto Mono" }}>
              function
            </span>
            <span style={{ color: "white", fontFamily: "Roboto Mono" }}>
              {`${value.toString().replace("function", "").split('{')[0]} {...}`}
            </span>
          </>
        );
      default:
        return <StringDatatype value={value.toString()} />;
    }
  }

  return <>{handleOutputDisplay(type)}</>;
}

export default DisplayData;
